import React from 'react';
import { AlertProps } from 'antd';

import { StyledAntdAlert } from './style';

const CVAlert = (props: AlertProps): JSX.Element => (
  <StyledAntdAlert {...props} />
);

export default CVAlert;
